import { makeStyles } from "@material-ui/core";


export default makeStyles((themes) => ({
appbar: {
    borderRadius: 15,
    backgroundColor: "white",
    margin: "30px 0 30px 0",
    justifyContent: "center"
}
,
mainContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}))